<template>
  <div v-if="paymentMethods">
    <div class="text-h6 text-uppercase text-weight-bold q-mb-md">
      {{ $t('payment.methods') }}
    </div>

    <div v-if="!currentDeliveryMethod">
      {{ $t('payment.noDeliveryChosen') }}
    </div>

    <div
      v-else
      class="row q-col-gutter-lg"
    >
      <div
        v-for="paymentMethod in availablePaymentMethods"
        :key="paymentMethod.id"
        :class="{
          'col-xs-12 col-sm-6 col-md-3': !catering,
          'col-12': catering,
        }"
        @click="selectPaymentMethod(paymentMethod)"
      >
        <div
          class="paymentMethod cursor-pointer text-body1
            rounded-borders q-py-lg q-px-md full-height
            row items-center"
          :class="{
            selected: selected === paymentMethod.id
          }"
        >
          <q-radio
            v-model="selected"
            color="secondary"
            :val="paymentMethod.id"
            @input="selectPaymentMethod(paymentMethod)"
            @click="selectPaymentMethod(paymentMethod)"
          >
            <div class="q-ml-md">
              <div
                v-if="isVerifone(paymentMethod) || isValitor(paymentMethod) || isAur(paymentMethod)"
                class="col-12"
              >
                <div v-if="isVerifone(paymentMethod)" class="col-12">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 73.68" v-bind:svg-inline="''" v-bind:width="'90px'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M89.336 72.493L78.854 40.388c-.066-.264.066-.396.33-.396h7.185c.132 0 .264 0 .33.198l7.91 25.25c.264.922 1.187.922 1.451 0l7.78-25.25c.065-.198.197-.198.329-.198h7.12c.197 0 .33.132.263.396l-10.35 32.105c-.066.198-.132.198-.264.198H89.6c-.132 0-.197 0-.263-.198zM111.481 56.47c0-9.618 6.144-17.467 16.405-17.467 11.548 0 16.888 9.232 16.213 18.722-.033.45-.193.61-.547.61H118.75c.643 5.47 4.342 8.75 9.296 8.75 4.214 0 6.498-1.833 7.881-4.47.129-.194.258-.29.483-.29h6.723c.128 0 .257.096.257.29 0 .835-1.64 5.339-5.34 7.944-2.702 2.06-6.08 3.12-10.004 3.12-9.779 0-16.566-7.108-16.566-17.209zm25.38-4.02c-1.19-4.6-4.471-6.852-9.103-6.852-4.407 0-7.56 2.573-8.75 6.851h17.853zM165.061 46.717h-2.76c-4.285 0-7.516 3.032-7.516 7.515v18.195a.283.283 0 01-.263.264h-6.659a.283.283 0 01-.263-.264v-32.17c0-.133.131-.265.263-.265h6.197c.132 0 .264.132.264.264v3.428c0 .593.725.857 1.187.264 1.977-2.637 4.944-3.956 7.515-3.956h2.035c.132 0 .264.132.264.264v6.197a.284.284 0 01-.263.264zM172.056 27.553c2.374 0 4.483 1.978 4.483 4.35 0 2.374-2.11 4.352-4.483 4.352-2.373 0-4.483-1.978-4.483-4.351s2.11-4.351 4.483-4.351zm-3.626 44.874v-32.17c0-.133.132-.265.264-.265h6.593c.132 0 .263.132.263.264v32.171a.283.283 0 01-.263.264h-6.593a.283.283 0 01-.263-.264zM183.396 72.427v-25.71h-4.475c-.132 0-.263-.132-.263-.264v-6.197c0-.132.131-.264.263-.264h4.475v-4.5c0-5.34 3.098-7.712 8.306-7.712h5.926c.132 0 .263.132.263.263v6.197a.284.284 0 01-.263.264h-4.343c-2.044 0-2.835.791-2.835 2.703v2.785h6.045c.131 0 .263.132.263.264v6.197a.284.284 0 01-.263.264h-6.045v25.71a.284.284 0 01-.264.264h-6.527a.283.283 0 01-.263-.264zM197.347 56.407c0-10.416 7.054-17.404 16.811-17.404 9.89 0 16.943 7.054 16.943 17.404 0 10.219-7.054 17.273-16.943 17.273-9.757 0-16.81-7.054-16.81-17.273zm16.811 10.483c5.736 0 9.823-4.022 9.823-10.483 0-6.592-4.021-10.613-9.823-10.613-5.67 0-9.625 4.087-9.625 10.613 0 6.395 4.022 10.483 9.625 10.483zM234.545 72.427v-32.17c0-.133.132-.265.264-.265h6.197c.131 0 .263.132.263.264v2.769c0 .593.791.857 1.253.263 1.78-2.373 4.483-4.087 8.9-4.087 7.45 0 12.46 4.945 12.46 12.46v20.766a.284.284 0 01-.264.264h-6.659a.284.284 0 01-.263-.264V53.375c0-4.615-2.967-7.384-7.252-7.384-4.483 0-7.713 3.099-7.713 7.582v18.854a.283.283 0 01-.264.264h-6.658a.283.283 0 01-.264-.264zM267.326 56.47c0-9.618 6.144-17.467 16.405-17.467 11.548 0 16.888 9.232 16.212 18.722-.032.45-.193.61-.547.61h-24.8c.643 5.47 4.342 8.75 9.296 8.75 4.213 0 6.497-1.833 7.88-4.47.13-.194.258-.29.483-.29h6.723c.129 0 .257.096.257.29 0 .835-1.64 5.339-5.34 7.944-2.701 2.06-6.079 3.12-10.003 3.12-9.78 0-16.566-7.108-16.566-17.209zm25.38-4.02c-1.19-4.6-4.472-6.852-9.104-6.852-4.407 0-7.56 2.573-8.75 6.851h17.853z"/><g><path d="M54.518 48.927c5.382 0 9.785-4.404 9.785-9.786 0-2.935-1.467-5.48-3.375-7.436-2.006-1.957-4.453-3.914-4.453-7.241s2.447-5.285 4.453-7.242c1.908-1.957 3.376-4.5 3.376-7.436C64.303 4.404 59.9 0 54.517 0c-5.43 0-9.785 4.404-9.785 9.786 0 2.935 1.419 5.48 3.327 7.436 2.006 1.957 4.452 3.914 4.452 7.241s-2.446 5.285-4.452 7.242c-1.908 1.957-3.327 4.5-3.327 7.436 0 5.382 4.354 9.786 9.785 9.786z"/><circle cx="32.152" cy="62.906" r="9.785"/><circle cx="9.785" cy="39.141" r="9.785"/><circle cx="9.785" cy="9.785" r="9.785"/></g></svg>
                </div>

                <div v-if="isValitor(paymentMethod)" class="col-12">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 166.186 25.226" v-bind:svg-inline="''" v-bind:width="'110px'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#1d5075" d="M27.84.011L22.25-.01c-.062.01-.118.033-.128.097l-8.201 18.97L5.887.084A.2.2 0 005.731 0H.159a.157.157 0 00-.136.069.158.158 0 00-.008.149l11.183 24.904c.016.068.068.104.137.104h5.137c.061.004.12-.04.143-.098L27.981.234c.014-.055.014-.107-.011-.151a.16.16 0 00-.13-.072m55.344 25.215c.089 0 .209-.068.209-.152L83.457.181c0-.093-.073-.166-.149-.166L78.687 0c-.086 0-.165.074-.154.162l-.063 24.896c0 .082.121.154.203.154l4.511.014zM108.75.001L87.534 0a.145.145 0 00-.111.044s-.049.071-.038.116l-.021 4.638c0 .078.089.156.171.156l8.163.025-.049 20.091c0 .096.066.16.148.16l4.624.016c.04 0 .077-.016.106-.049a.17.17 0 00.049-.107l.055-20.106 8.119.025c.043.003.078-.022.107-.04a.352.352 0 00.057-.126l.006-4.688a.157.157 0 00-.17-.154M44.77 0h-7.605c-4.328-.006-7.875 3.516-7.887 7.847l-.041 17.205c0 .044.02.092.045.115a.17.17 0 00.111.044h4.62a.173.173 0 00.164-.156l.01-8.66 13.484.033.004 8.633c0 .084.079.15.165.15h4.61c.047 0 .087-.011.116-.044l.044-.073V7.901C52.624 3.568 49.11.006 44.77 0M34.206 11.432l.01-3.57c0-1.616 1.322-2.934 2.924-2.92l7.625.011a2.937 2.937 0 012.927 2.944l-.012 3.573-13.474-.038zm131.98-3.524c0-4.333-3.709-7.863-8.039-7.867L141.949 0c-.082 0-.211.064-.211.156l-.067 24.917c0 .082.069.159.146.159l4.652.009a.178.178 0 00.103-.042.2.2 0 00.052-.117l.003-8.705 11.264.029c1.522 0 2.894 1.171 2.894 2.526l-.003 6.146c0 .092.062.148.147.148l5.258.012v-.103s-.32-5.433-.567-6.996-.77-2.982-1.822-4.13c1.393-1.429 2.39-3.312 2.39-5.297v-.804zm-5.344.76c-.059 1.399-1.509 2.774-2.679 2.774l-11.978-.029V4.941l11.521.02c1.616.003 3.049 1.326 3.043 2.948.001.033.112.681.093.759M74.059 20.733a.157.157 0 00-.164-.162l-11.369-.033.035-20.374a.155.155 0 00-.049-.115.173.173 0 00-.118-.049l-4.642.009c-.085 0-.107.063-.11.155l-.053 22.815c-.006 1.099.593 2.26 2.254 2.26l14.048-.013a.142.142 0 00.104-.048c.025-.038.049-.067.049-.111l.015-4.334z"/><path fill="#4e9da5" d="M129.109.019L119.407 0c-4.338-.011-7.877 3.509-7.883 7.842l-.029 9.485c-.01 4.105 3.05 7.494 7.117 7.883l1.458-.017 9.624-.003h.089c4.077 0 7.146-3.724 7.157-7.824l.022-9.478c.011-4.328-3.508-7.862-7.853-7.869m2.911 17.361c-.016 1.526-1.1 2.774-2.514 2.904l-10.595-.019c-1.412-.134-2.493-1.394-2.483-2.923l.02-9.486a2.93 2.93 0 012.948-2.923l9.713.018a2.925 2.925 0 012.92 2.938l-.009 9.491z"/></svg>
                </div>

                <div v-if="isAur(paymentMethod)" class="col-12">
                  <q-img
                    svg-inline
                    width="48px"
                    src="~quasar-pilot-core/src/assets/aur-logo.svg"
                  />
                </div>

                <div class="q-mt-xs text-body1">
                  {{ translateTitle(paymentMethod) }}
                </div>
              </div>

              <div v-else class="text-weight-regular text-h6">
                {{ translateTitle(paymentMethod) }}
              </div>

              <div
                v-if="paymentMethod.priceImpact"
                class="text-weight-regular text-body2"
              >
                {{ paymentMethod.priceImpact }} kr.
              </div>
            </div>
          </q-radio>
        </div>
      </div>

      <div
        v-if="showOptionsField"
        :class="{
          'col-xs-12 col-md-6': !catering,
          'col-12': catering,
        }"
      >
        <div
          class="paymentMethod selected row text-body1 text-center
          rounded-borders q-py-lg q-pl-lg full-height full-width items-center"
        >
          <PaymentCardForm
            v-if="selectedIsValitor || selectedIsVerifone"
            class="col-12"
          />

          <PaymentAurForm
            v-if="selectedIsAur"
            class="col-12"
          />

          <div
            v-if="selectedIsValitorPage"
            class="col-12"
          >
            Greiðsla mun fara fram á greiðslusíðu Valitor.
          </div>

          <div
            v-if="selectedIsVerifoneCheckout"
            class="col-12"
          >
            Greiðsla mun fara fram á greiðslusíðu Verifone.
          </div>
          <div
            v-if="selectedIsInvoice"
            class="col-12"
          >
            Upphæð verður sett í reikning á kennitölu {{ externalId }}
          </div>
          <InvoiceAuthForm
            v-if="selectedIsInvoiceQR"
            class="col-12"
          />
        </div>
      </div>
    </div>

    <component
      v-if="hasVerifone"
      :src="verifoneJsUrl"
      :is="'script'"
    />
    <component
      v-if="hasVerifone"
      :src="songbirdUrl"
      :is="'script'"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import language from '../../mixins/util/language';
import PaymentAurForm from '../payment/AurForm';
import PaymentCardForm from '../payment/CardForm';
import InvoiceAuthForm from '../payment/InvoiceAuthForm';
import { constants } from '../../lib/constants';

const release = process.env.RELEASE;
// const release = 'production';

const verifoneJsUrl = release === 'production'
  ? 'https://emea.jsclient.verifone.cloud/verifone.js'
  : 'https://cst.jsclient.vficloud.net/verifone.js';

const songbirdUrl = release === 'production'
  ? 'https://songbird.cardinalcommerce.com/edge/v1/songbird.js'
  : 'https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js';

export default {
  name: 'OrderPaymentMethods',
  components: { InvoiceAuthForm, PaymentCardForm, PaymentAurForm },
  mixins: [language],

  props: {
    catering: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showOptionsField: false,
      selected: null,
      verifoneJsUrl,
      songbirdUrl,
    };
  },

  computed: {
    ...mapState('payment', { paymentMethods: 'all' }),
    ...mapState('order', {
      currentPaymentMethod: 'paymentMethod',
      currentDeliveryMethod: 'deliveryMethod',
    }),
    ...mapState('user', ['externalId', 'role']),
    ...mapState('application', ['isQR']),

    selectedIsVerifone() {
      return (this.currentPaymentMethod?.type === constants.PAYMENT_METHOD_TYPE_VERIFONE);
    },

    selectedIsVerifoneCheckout() {
      return (this.currentPaymentMethod?.type === constants.PAYMENT_METHOD_TYPE_VERIFONECHECKOUT);
    },

    selectedIsValitor() {
      return (this.currentPaymentMethod?.type === constants.PAYMENT_METHOD_TYPE_VALITOR);
    },

    selectedIsValitorPage() {
      return (this.currentPaymentMethod?.type === constants.PAYMENT_METHOD_TYPE_VALITORPAGE);
    },

    selectedIsAur() {
      return (this.currentPaymentMethod?.type === constants.PAYMENT_METHOD_TYPE_AUR);
    },

    selectedIsKass() {
      return (this.currentPaymentMethod?.type === constants.PAYMENT_METHOD_TYPE_KASS);
    },

    selectedIsInvoice() {
      return (this.currentPaymentMethod?.type === constants.PAYMENT_METHOD_TYPE_INVOICE && !this.isQR);
    },

    selectedIsInvoiceQR() {
      return (this.currentPaymentMethod?.type === constants.PAYMENT_METHOD_TYPE_INVOICE && this.isQR);
    },

    availablePaymentMethods() {
      if (this.externalId) {
        return this.currentDeliveryMethod.paymentMethods
      }
      return this.currentDeliveryMethod.paymentMethods.filter((p) => p.type !== 100)
    },

    hasVerifone() {
      if (this.currentDeliveryMethod && this.currentDeliveryMethod.paymentMethods) {
        return (this.currentDeliveryMethod.paymentMethods.find(
          (p) => p.type === constants.PAYMENT_METHOD_TYPE_VERIFONE
        ));
      }

      return false;
    }
  },

  watch: {
    currentPaymentMethod() {
      if (!this.currentPaymentMethod) {
        this.showOptionsField = false;
        this.selected = null;
      }
    }
  },

  created() {
    if (this.currentPaymentMethod) {
      this.selectPaymentMethod(this.currentPaymentMethod);
    }
    else if (!this.currentPaymentMethod && this.currentDeliveryMethod) {
      // Automatically select the first payment option
      this.selectPaymentMethod(this.currentDeliveryMethod.paymentMethods[0]);
    }
  },

  methods: {
    ...mapActions('order', ['updateTotalPrice']),
    ...mapMutations('order', ['updatePaymentMethod']),

    isVerifone(paymentMethod) {
      return (paymentMethod.type === constants.PAYMENT_METHOD_TYPE_VERIFONE
        || paymentMethod.type === constants.PAYMENT_METHOD_TYPE_VERIFONECHECKOUT);
    },

    isValitor(paymentMethod) {
      return (paymentMethod.type === constants.PAYMENT_METHOD_TYPE_VALITOR
        || paymentMethod.type === constants.PAYMENT_METHOD_TYPE_VALITORPAGE);
    },

    isAur(paymentMethod) {
      return (paymentMethod.type === constants.PAYMENT_METHOD_TYPE_AUR);
    },

    selectPaymentMethod(paymentMethod) {
      this.updatePaymentMethod(paymentMethod);
      this.updateTotalPrice();
      this.selected = paymentMethod.id;
      this.showOptionsField = (this.currentPaymentMethod.type > 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.paymentMethod {
  border: 1px solid $table-border-color;
}

.selected {
  border-color: $secondary;
}
</style>
